// Central brand system — official Clacton Fireworks emblem (transparent PNG, used as-is).
export const BRAND_ICON =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-reserve-hub/artifacts/hohz83j4_Logo%20V2.png";
export const BRAND_LOGO = BRAND_ICON;
// Favicon — centre firework icon extracted from the logo.
export const BRAND_FAVICON =
  "https://static.prod-images.emergentagent.com/jobs/1b6a2df0-aad5-473f-8025-00bad8c17ce1/images/2dd09e1f376cfa16d768714d19f82488d9e2a34f5b21e0e344fcc53d1e54d68c.jpeg";
// Open Graph / social share image.
export const BRAND_OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/1b6a2df0-aad5-473f-8025-00bad8c17ce1/images/6f4250a80570c883a1f010dc030bdd6a58263b27f7e1c08db960047692ecd731.jpeg";

// Dedicated WEBSITE HEADER logo — a horizontal logo will be supplied shortly.
// When provided, set this to its URL and the header renders it across the
// reserved horizontal slot. While blank, the header falls back to a small,
// low-emphasis circular emblem. (The circular logo remains the primary brand
// mark for marketing/social.)
export const HEADER_LOGO = "";

export const IMG = {
  sparklers:
    "https://static.prod-images.emergentagent.com/jobs/1b6a2df0-aad5-473f-8025-00bad8c17ce1/images/dca288818d21ad3d648a359cc6fac520fd549fdffc22b97389a4cf10d016c739.png",
  selectionBox:
    "https://static.prod-images.emergentagent.com/jobs/1b6a2df0-aad5-473f-8025-00bad8c17ce1/images/0b226d4b99200ec065c4baad01a04c9dc80dd9d199595fb94fbd3b42f02726ba.png",
  displayDouble:
    "https://images.unsplash.com/photo-1503847977400-9b90e320db5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rocket:
    "https://images.unsplash.com/photo-1457365050282-c53d772ef8b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fountain:
    "https://images.unsplash.com/photo-1625456809070-da1680787f5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  barrage:
    "https://images.unsplash.com/photo-1598817123719-b2407ba2f6d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  familyBlue:
    "https://images.unsplash.com/photo-1675808416578-b80c88e09919?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  familyCouple:
    "https://images.unsplash.com/photo-1552912470-6319f36ef5e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bigDisplay:
    "https://images.unsplash.com/photo-1551623071-5f000add6421?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
} as const;

export const PALETTE = {
  ink: "#05070D",
  navy: "#0B1020",
  gold: "#E8B54B",
  goldLight: "#FCF6BA",
  goldDark: "#B38728",
  silver: "#D1D5DB",
  silverLight: "#F3F4F6",
  red: "#D23B2E",
  orange: "#F2761B",
} as const;
